export class SubmittedRosterRequest {
    rosterNo: number = 0;
    accessId: number = 0;
    accessLevel: number = 0;
    userId?: string = "";

    constructor(rosterNo: number, accessId: number, accessLevel: number) {
        this.rosterNo = rosterNo;
        this.accessId = accessId;
        this.accessLevel = accessLevel;
    }
}